import React from 'react';
import { useTabNavContext } from '../../tab-nav-context';
import StickyTabNavigation from 'src/components/sticky-tab-nav';
import { useProductPageNavExperiment } from 'src/hooks/experiments';
import { useNavigationLinks } from './utils';
import { TabAnchor } from '../product-tabs/types';

export const ProductNavigation: React.FC = () => {
  const navigationTabs = useNavigationLinks();
  const newTabNav = useProductPageNavExperiment();

  const { activeTab } = useTabNavContext();

  const handleTabClick = () => {
    // Always scroll to top if Experiment variant
    // TODO: handle within onClick in tabs-new/index for the experiment variant when experiment is done.
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <StickyTabNavigation
      borderBottom={newTabNav && activeTab !== TabAnchor.ALL}
      defaultActiveTabId={activeTab}
      tabs={navigationTabs}
      background
      shouldScrollOnClick={!newTabNav}
      onClick={newTabNav ? handleTabClick : undefined}
    />
  );
};
